import { ref, computed, onMounted, onUnmounted } from 'vue';

// Firebase SDK is disabled. Hosting only.
export const firebaseApp = null;
export const db = null;
export const storage = null;
export const functions = null;

export const getUserState = () => {
  return new Promise((resolve) => {
    const uid = localStorage.getItem('uid') || sessionStorage.getItem('uid');
    resolve({ uid });
  });
};

export const auth = null;
export const useAuthState = () => {
  const user = ref(null);
  const error = ref(null);

  let unsubscribe = () => {};

  onMounted(() => {
    try {
      const uid = localStorage.getItem('uid') || sessionStorage.getItem('uid');
      user.value = uid ? { uid } : null;
    } catch (e) {
      error.value = e;
    }
  });

  onUnmounted(() => {
    unsubscribe();
  });

  const isAuthenticated = computed(() => user.value != null);
  return { user, error, isAuthenticated, auth };
};
